import type { I18nTranslation } from '@crehana/i18n';

import localeEn from './localeEn';
import localeEs from './localeEs';
import localePt from './localePt';

export type { UserStudyPlanTranslationKeys } from './types';

const locales: I18nTranslation = { es: localeEs, pt: localePt, en: localeEn };

export { localeEn, localeEs, localePt };
export default locales;
